'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.switchLanguage = switchLanguage;
exports.default = i18n;

var _i18nProvider = require('../i18n-provider');

var routeControllerObj = void 0; /**这个plugin需要配合，I18nProvider使用**/
function switchLanguage(language) {
  var reload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  (0, _i18nProvider.switchLanguage)(language).then(function (languageList) {
    if (reload) {
      location.reload();
    } else {
      routeControllerObj.reRender();
    }
  });
}
function i18n(routeController) {
  routeControllerObj = routeController;
  return {
    displayName: 'i18n',
    switchLanguage: switchLanguage,
    t: _i18nProvider.t
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/mvc-react/libs/plugin/i18n.js
// module id = 1227
// module chunks = 0